import {makeAutoObservable, observable, runInAction} from "mobx"

interface MessageLink {
    text: string
    url: string
    /** Open in a new tab instead of navigating the current one (e.g. so exporting from the
     *  ET doesn't tear down the editor when you click "View in My Library"). */
    newTab?: boolean
}

class MessageStore {
    // give user feed back on the app
    message = ''
    level = 'error'
    duration = 4000
    link: MessageLink | null = null


    constructor() {
        makeAutoObservable(this, {
            message: observable,
            level: observable,
            duration: observable,
            link: observable,
        })
    }

    setMessage = (message: string, level: string = "success", duration: number = 6000, link: MessageLink | null = null) => {
        runInAction(() => {
            this.message = message
            this.level = level
            this.duration = duration
            this.link = link
        })
    }
    getMessage = () => ({message: this.message, level: this.level, duration: this.duration, link: this.link})

    resetMessage = () => runInAction(() => { this.message = ''; this.link = null; })

}

const messageStore = () => new MessageStore()

export default messageStore
